import { useQuery } from '@tanstack/react-query'
import { ExtendableQueryOptions } from 'shared/api/api.types'

import { taskManagementApi } from '../..'
import { GetLiveChatContactPersonResponse } from './getLiveChatContactPerson.types'

export const getLiveChatContactPerson = async (contactPersonId: number) => {
  const response =
    await taskManagementApi.get<GetLiveChatContactPersonResponse>(
      '/api/live-chats/contact-person',
      { params: { contact_person_id: contactPersonId } }
    )

  return response.data.data
}

export const GET_LIVE_CHAT_CONTACT_PERSON_QUERY_KEY = 'getLiveChatContactPerson'

export const useGetLiveChatContactPersonQuery = (
  contactPersonId: number,
  options?: ExtendableQueryOptions<GetLiveChatContactPersonResponse['data']>
) =>
  useQuery({
    queryKey: [GET_LIVE_CHAT_CONTACT_PERSON_QUERY_KEY, contactPersonId],
    queryFn: () => getLiveChatContactPerson(contactPersonId),
    ...options
  })
